import { render, staticRenderFns } from "./OtrosDialog.vue?vue&type=template&id=23b80f02&"
import script from "./OtrosDialog.vue?vue&type=script&lang=js&"
export * from "./OtrosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports